import classNames from "classnames";
import HotkeyIcon, { HotkeyIconProps } from "components/HotkeyIcon";
import useIsMac from "hooks/useIsMac";

/**
 * @description A component that displays a command or control key icon and a K icon depending on the user's operating system.
 */
export default function CommandOrControlKIconGroup(
  props: Omit<HotkeyIconProps, "hotkey">
) {
  const isMac = useIsMac();
  const { size = "md" } = props;
  return (
    <div
      className={classNames("flex", {
        "gap-0.5": size === "sm",
        "gap-1": size === "md",
      })}
    >
      <HotkeyIcon hotkey={isMac ? "⌘" : "Ctrl"} {...props} />
      <HotkeyIcon hotkey="K" {...props} />
    </div>
  );
}
